import React from 'react';
import MViewSummaryAnswerFormListItems from './MViewSummaryAnswerFormListItems';

export default function MViewSummaryFormList(props) {
  const {
    auth,
    scope,
    state,
    questions,
    onChangeInput,
    handleEnter,
    isEdit,
    roundNumber,
  } = props;
  return (
    <>
      {questions &&
        questions[0] &&
        questions.map((question, index) => (
            <MViewSummaryAnswerFormListItems
              key={index}
              index={index}
              auth={auth}
              scope={scope}
              state={state}
              question={question}
              onChangeInput={onChangeInput}
              handleEnter={handleEnter}
              isEdit={isEdit}
              roundNumber={roundNumber}
            />
        ))}
      {questions && questions.length === 0 && (
        <tr>
          <td colSpan='7'>Tidak ada data</td>
        </tr>
      )}
    </>
  );
}
